
import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataTreatmentNotes extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().patient_home_created_by, value: data.CreatedBy },
            { name: CurrentLang().patient_home_date_time_created, value: StringUtils.formatDateOrNoData(data.DateTimeCreated, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_last_edited, value: StringUtils.formatDateOrNoData(data.DateTimeEdited, CurrentLang().no_data) }];

        return tableData;
    }
}


export default MagstimTableDataTreatmentNotes;
